import { render, staticRenderFns } from "./AccompanyMeal.vue?vue&type=template&id=01525296&scoped=true&"
import script from "./AccompanyMeal.vue?vue&type=script&lang=ts&"
export * from "./AccompanyMeal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01525296",
  null
  
)

export default component.exports